import React from 'react';
import { Linkedin, Mail, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const linkGroups = [
    {
      title: 'Navigation',
      links: [
        { label: 'AI Agents', href: '/#agents' },
        { label: 'Receptionist', href: '/#receptionist' },
        { label: 'ROI Calculator', to: '/roi-calculator' },
        { label: 'Migration', href: '/#migration' },
      ]
    },
    {
      title: 'Solutions',
      links: [
        { label: 'Front Office Suite', to: '/solutions/front-office-suite' },
        { label: 'Back Office Suite', to: '/solutions/back-office-suite' },
        { label: 'Private Practices', to: '/solutions/private-practices' },
        { label: 'DSOs', to: '/solutions/dsos' },
      ]
    },
    {
      title: 'Resources',
      links: [
        { label: 'Blog', to: '/blog' },
        { label: 'Contact', to: '/contact' },
      ]
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy Policy', to: '/privacy-policy-2026' },
        { label: 'Business Associate Agreement', to: '/baa' },
        { label: 'Trust Center', href: 'https://trust.oneleet.com/asha-health', external: true },
      ]
    },
  ];

  return (
    <footer className="bg-[#0A0A12] text-white pt-16 pb-10 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Top: Logo */}
        <div className="flex flex-col lg:flex-row gap-10 mb-14 pb-14 border-b border-white/[0.06]">
          <div className="lg:max-w-sm">
            <Link to="/" className="flex items-center space-x-2.5 mb-4">
              <img src="/assets/alogo.png" alt="Asha Dental Logo" className="h-9 w-auto" />
              <span className="font-semibold text-xl text-white">Asha Dental</span>
            </Link>
            <p className="text-white/35 text-sm leading-relaxed max-w-sm">
              Transforming dental practices with AI-powered solutions that streamline operations, enhance patient care, and drive growth.
            </p>
          </div>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-14">
          {linkGroups.map(group => (
            <div key={group.title}>
              <h4 className="font-semibold text-sm text-white/70 mb-4 uppercase tracking-wider">{group.title}</h4>
              <ul className="space-y-3">
                {group.links.map(link => (
                  <li key={link.label}>
                    {link.to ? (
                      <Link to={link.to} className="text-white/35 hover:text-white text-sm transition-colors duration-200">{link.label}</Link>
                    ) : (
                      <a href={link.href} {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})} className="text-white/35 hover:text-white text-sm transition-colors duration-200">{link.label}</a>
                    )}
                  </li>
                ))}
                {group.title === 'Legal' && (
                  <li>
                    <a href="https://trust.oneleet.com/asha-health" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-white/35 hover:text-white text-sm transition-colors duration-200">
                      <ShieldCheck className="w-4 h-4 text-green-400" />
                      <span>HIPAA Compliant</span>
                    </a>
                  </li>
                )}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/[0.06] space-y-4 md:space-y-0">
          <div className="text-white/25 text-sm">
            Copyright 2026 ASHA Health Inc. All rights reserved.
          </div>
          <div className="flex items-center space-x-3">
            <a href="https://www.linkedin.com/company/asha-health-ai/" className="flex items-center justify-center w-9 h-9 rounded-full bg-white/[0.05] text-white/30 hover:bg-blue-600 hover:text-white transition-all duration-200" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
              <Linkedin className="w-4 h-4" />
            </a>
            <a href="mailto:sales@asha.health" className="flex items-center justify-center w-9 h-9 rounded-full bg-white/[0.05] text-white/30 hover:bg-blue-600 hover:text-white transition-all duration-200" aria-label="Email">
              <Mail className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
